// extracted by mini-css-extract-plugin
export default {"list":"wa","logo":"xa","blinking":"ya"};